import React from 'react'
import { BlockedUserListItem } from './BlockedUserListItem'

interface BlockedUsersListProps {
  users: {
    userId: string
  }[]
}

export const BlockedUsersList = ({
  users,
}: BlockedUsersListProps): JSX.Element => {
  return (
    <div className="h-full w-full space-y-4">
      {users.map((user) => (
        <BlockedUserListItem key={user.userId} userId={user.userId} />
      ))}
    </div>
  )
}
